import { useEffect, useState } from "react";
import Header from "./Header";
// import { fetchDropDownByCategory } from "../../service/DropDownService";
import { fetchAllAdvertisement, fetchAllAdvAttachments } from "../../service/AdService";
import { apiUrl } from "../../config";
import UserFooter from "./UserFooter";
import { fetchDropdownByCategoryWise } from "../../service/DropdownService";
import { useParams, useSearchParams } from "react-router-dom";
import { fetchAllVisitingTime, fetchVisitingTimeByAdId } from "../../service/VisitingTime";
import '../../styles/App.css'
import MoreDetailsAttachmentButton from "./MoreDetailsAttachmentButton";
import AdvertisementSocialLinks from "./AdvertisementSocialLinks";
import { mergeAdsWithAttachments } from "../../utils/advertisementAttachments";

const CategoryBox = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [categoryList, setCategoryList] = useState([]);
  const [dropdownList, setDropdownList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(
    searchParams.get("category") || id || "Accident / Emergency",
  );
  const [showVisitModal, setShowVisitModal] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState([]);
  const [visitTitle, setVisitTitle] = useState("");


  useEffect(() => {
    const categoryFromUrl = searchParams.get("category");
    if (categoryFromUrl) {
      setSelectedCategory(categoryFromUrl);
    } else if (id) {
      setSelectedCategory(id);
    }
  }, [searchParams, id]);

  useEffect(() => {

    getAdvertisement();
  }, []);
  const getAdvertisement = async () => {
    try {
      const [ads, allVisitingTimes, allAttachments] = await Promise.all([
        fetchAllAdvertisement(),
        fetchAllVisitingTime(),
        fetchAllAdvAttachments(),
      ]);

      const adsWithVisitingTimes = mergeAdsWithAttachments(ads, allAttachments).map((ad) => ({
        ...ad,
        visitingTimes: allVisitingTimes.filter((v) => v.adId === ad.id),
      }));

      setCategoryList(adsWithVisitingTimes);
    } catch (err) {
      console.error("Failed to fetch category list:", err);
    }
  };


  useEffect(() => {
    const getCategories = async () => {
      try {
        const data = await fetchDropdownByCategoryWise("HealthCare Category");
        const sortedData = data.sort((a, b) => a.title.localeCompare(b.title));
        setDropdownList(sortedData);
      } catch (err) {
        console.error("Failed to fetch dropdown list:", err);
      }
    };
    getCategories();
  }, []);

  const filteredCategoryList = selectedCategory
    ? categoryList.filter((item) => item.category === selectedCategory)
    : categoryList;

  const openVisitModal = (visit) => {
    // setVisitTitle(item.title); 
    setSelectedDetails(visit);
    setShowVisitModal(true);
  }

  const renderCards = (list) => (
    <>
      {list.map((item, idx) => (
        <div key={idx} className="col-12 mb-4 d-flex justify-content-center">
          <div className="result-card w-100 p-3 shadow-sm border rounded-5">
            <div className="d-flex flex-column flex-md-row align-items-start gap-3">
              <img
                src={
                  item.imageUrl
                    ? apiUrl + "/" + item.imageUrl
                    : "/images/hospital.jpg"
                }
                alt={item.title}
                className="img-fluid"
                style={{ maxWidth: "150px", borderRadius: "10px" }}
              />
              <div className="result-details">
                <h5 className="fw-bold">{item.title}</h5>
                {[item.address1, item.address2, item.address3, item.address4]
                  .filter(Boolean)
                  .map((line, i) => (
                    <div key={i}>{line},</div>
                  ))}
                {[item.phoneNo1, item.phoneNo2, item.phoneNo3]
                  .filter(Boolean)
                  .map((phone, i) => (
                    <div key={i}>{phone}</div>
                  ))}
                <div className="d-flext gap-2">
                  {item.visitingTimes && item.visitingTimes.length > 0 && (
                    <button
                      className="btn btn-secondary mt-2"
                      onClick={() => openVisitModal(item.visitingTimes)}
                    >
                      Visiting Details
                    </button>
                  )}
                  {(item.webUrl) && (
                    <a
                      href={item.webUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-info text-white mt-2"
                    >
                      More Details
                    </a>
                  )}
                  <MoreDetailsAttachmentButton item={item} variant="healthcare" />
                </div>
                <AdvertisementSocialLinks item={item} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );

  return (
    <>
      <Header />
      <div className="row ">
        <div className="col-12 marquee-row ">
          <marquee
            className="marquee-announcement"
            behavior="scroll"
            direction="left"
          >
            <div style={{ display: "inline-block", whiteSpace: "nowrap" }}>
              <span role="img" aria-label="announcement" className="fs-5 me-2">
                📢
              </span>
              <span className="fw-bold ">
                Hospital Advertisement: Please Contact-{" "}
                <a
                  href="#"
                  style={{
                    textDecoration: "none",
                    color: "#ffffff",
                    marginLeft: "10px",
                  }}
                >
                  <span>
                    <i className="fas fa-phone me-2"></i>
                  </span>
                  04362 - 238 235,{" "}
                </a>
                For Advertisement{" "}
                <span
                  role="img"
                  aria-label="announcement"
                  className="fs-5 me-2"
                >
                  🎉
                </span>
              </span>
            </div>
          </marquee>
        </div>
      </div>
      <div className="container-fluid category-page-content pb-5 mb-4">
        <div className="row">
          {/* Desktop view */}

          <div
            className="col-md-3 p-4 d-none d-md-block"
            style={{ background: "#00B3FF" }}
          >
            <h4 className="fw-bold mb-4 text-white">CATEGORIES</h4>

            <ul className="list-unstyled">
              {dropdownList.map((item, index) => (
                <CategoryItem
                  category={item.title}
                  key={index}
                  onClick={() => {
                    setSelectedCategory(item.title);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                />
              ))}
            </ul>
          </div>

          <div className="col-12 col-md-9 border-top border-bottom border-info">
            {/* Mobile accordion view */}
            <div className="d-block d-md-none mb-3">
              <div className="accordion" id="categoryAccordion">
                {dropdownList.map((item, index) => {
                  const categoryAds = categoryList.filter(
                    (ad) => ad.category === item.title
                  );
                  const isFirst = index === 0;
                  return (
                    <div className="accordion-item" key={index}>
                      <h2 className="accordion-header" id={`heading-${index}`}>
                        <button
                          className={`accordion-button ${isFirst ? "" : "collapsed"
                            }`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse-${index}`}
                          aria-expanded={isFirst ? "true" : "false"}
                          aria-controls={`collapse-${index}`}
                        >
                          {item.title}
                        </button>
                      </h2>
                      <div
                        id={`collapse-${index}`}
                        className={`accordion-collapse collapse ${isFirst ? "show" : ""
                          }`}
                        aria-labelledby={`heading-${index}`}
                        data-bs-parent="#categoryAccordion"
                      >
                        <div className="accordion-body">
                          {categoryAds.length > 0 ? (
                            renderCards(categoryAds)
                          ) : (
                            <div className="text-muted fw-bold text-center">
                              No items found in this category.
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Desktop category results */}
            <div className="row d-none d-md-flex">
              {selectedCategory && (
                <h3 className="mb-3 bg-light rounded p-3 text-dark fw-bold text-center">
                  {selectedCategory}
                </h3>
              )}
              {filteredCategoryList.map((item, idx) => (
                <div
                  key={idx}
                  className="col-12 mb-4 d-flex justify-content-center"
                >
                  <div className="result-card w-100 p-3 shadow-sm border rounded-5">
                    <div className="d-flex flex-column flex-md-row align-items-start gap-3">
                      <img
                        src={
                          item.imageUrl
                            ? apiUrl + "/" + item.imageUrl
                            : "/images/hospital.jpg"
                        }
                        alt={item.title}
                        className="img-fluid"
                        style={{ maxWidth: "150px", borderRadius: "10px" }}
                      />
                      <div className="result-details">
                        <h5 className="fw-bold">{item.title}</h5>
                        {[
                          item.address1,
                          item.address2,
                          item.address3,
                          item.address4,
                        ]
                          .filter(Boolean)
                          .map((line, i) => (
                            <div key={i}>{line},</div>
                          ))}
                        {[item.phoneNo1, item.phoneNo2, item.phoneNo3]
                          .filter(Boolean)
                          .map((phone, i) => (
                            <div key={i}>{phone}</div>
                          ))}
                        <div className="d-flex gap-2">
                          {item.visitingTimes && item.visitingTimes.length > 0 && (
                            <button
                              className="btn btn-secondary mt-2"
                              onClick={() => openVisitModal(item.visitingTimes)}
                            >
                              Visiting Details
                            </button>
                          )}
                          {(item.webUrl) && (
                            <a
                              href={item.webUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-info text-white mt-2"
                            >
                              More Details
                            </a>
                          )}
                          <MoreDetailsAttachmentButton item={item} variant="healthcare" />
                        </div>
                        <AdvertisementSocialLinks item={item} />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {filteredCategoryList.length === 0 && selectedCategory && (
                <h4 className="text-center text-muted fw-bold mt-5">
                  No items found for selected category.
                </h4>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <Footer />
       */}
      <UserFooter />

      {showVisitModal && (
        <div className="vt-overlay" onClick={() => setShowVisitModal(false)}>
          <div
            className="vt-card"
            onClick={(e) => e.stopPropagation()} 
          >
            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
              <h5 className="fw-bold mb-0"> Visiting Details </h5>
              <button className="btn-close" onClick={() => setShowVisitModal(false)}></button>
            </div>

            {selectedDetails.map((v, i) => (
              <div key={i} className="mb-3 border-bottom pb-2">
                <p className="text-dark text-capitalize">
                  <strong>Place:</strong> {v.location}
                </p>
                <p className="text-dark text-capitalize">
                  <strong>Days:</strong> {v.days}
                </p>
                <p className="text-dark text-capitalize">
                  <strong>Time:</strong> {v.time}
                </p>
              </div>
            ))}

            <div className="text-end mt-3">
              <button className="btn btn-secondary" onClick={() => setShowVisitModal(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}


    </>
  );
};

export default CategoryBox;

const CategoryItem = ({ category, onClick }) => (
  <li className="mb-2">
    <div
      className="d-flex align-items-center gap-2"
      role="button"
      onClick={onClick}
    >
      <i className="fas fa-heartbeat fa-1x text-white"></i>
      <span className=" text-white text-decoration-none">{category}</span>
    </div>
  </li>
);
